module.exports = __webpack_public_path__ + "media/images/button-right-16ae1cfb36ab721e05a02ce6f00d1177.svg";